import { createMuiTheme } from "@material-ui/core";

export const theme = createMuiTheme({
  typography: {
    fontFamily: [
      "Montserrat",
      "sans-serif"
    ].join(","),
  },
});
